import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    template: '<mat-progress-spinner mode="indeterminate"></mat-progress-spinner>',
    standalone: true,
    imports: [MatProgressSpinnerModule]
})
export class LoadSpinnerComponent { }
